const hoverTargets = document.querySelectorAll('[data-hover-target]');

hoverTargets.forEach((target) => {
  target.addEventListener('mouseover', (event) => {
    const targetContent = target.querySelector('[data-hover-content]');
    targetContent.classList.add('active');
    targetContent.addEventListener('mouseleave', (event) => {
      targetContent.classList.remove('active');
    });

    target.closest('section').addEventListener('mousemove', (event) => {
      const rect = target.getBoundingClientRect();
      console.log('RECT', rect);
      const elementCenterX = rect.left + rect.width / 2;
      const elementCenterY = rect.top + rect.height / 2;
      const distance = Math.sqrt(
        Math.pow(event.clientX - elementCenterX, 2) +
          Math.pow(event.clientY - elementCenterY, 2)
      );
      console.log(distance, 'DISTANCE');
      const threshold = 450; // Distance in pixels

      if (distance > threshold) {
        //  console.log('Mouse is more than ' + threshold + ' pixels away from the element.');
        targetContent.classList.remove('active');
      }
    });
  });
});
